import cx from 'classnames'

import styles from './SpecialOfferRibbon.module.scss'

export const SpecialOfferRibbonSVG = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="44"
      viewBox="0 0 97 44"
      fill="none"
      className={cx(styles.svgElement, styles[color])}
      preserveAspectRatio="none"
    >
      <g filter="url(#filter0_i_5769_48424)">
        <path
          d="M5.36126 7.22132C5.45534 5.95525 6.4834 4.96072 7.75189 4.90867L53.2222 3.04272C53.7901 3.01941 54.2632 3.47351 54.2632 4.04188V4.83777C54.2632 6.28023 55.4805 7.42341 56.9201 7.33284L91.1374 5.1801C92.6508 5.08488 93.8998 6.34814 93.7875 7.86041L91.6351 36.827C91.5426 38.0723 90.5453 39.0584 89.299 39.1368L52.7996 41.4331C52.2238 41.4694 51.7368 41.0121 51.7368 40.4351V38.6586C51.7368 37.2175 50.5216 36.0748 49.0832 36.1633L5.85897 38.824C4.34675 38.9171 3.09998 37.6544 3.21225 36.1435L5.36126 7.22132Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M7.70063 3.65972C5.7979 3.7378 4.25581 5.2296 4.1147 7.12869L1.96568 36.0509C1.79729 38.3172 3.66744 40.2113 5.93577 40.0717L49.16 37.411C49.8792 37.3667 50.4868 37.9381 50.4868 38.6586V40.4351C50.4868 41.7333 51.5825 42.7622 52.8781 42.6807L89.3775 40.3843C91.2469 40.2667 92.7429 38.7876 92.8817 36.9196L95.034 7.95304C95.2026 5.68463 93.329 3.78974 91.0589 3.93257L56.8416 6.08531C56.1218 6.13059 55.5132 5.559 55.5132 4.83777V4.04188C55.5132 2.76304 54.4487 1.74134 53.1709 1.79377L7.70063 3.65972Z"
        stroke="black"
        strokeWidth="2.5"
      />
      <defs>
        <filter
          id="filter0_i_5769_48424"
          x="0.705078"
          y="0.541748"
          width="95.5896"
          height="43.3936"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0" dy="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5769_48424" />
        </filter>
        <linearGradient id="paint0_linear_5769_48424" x1="-45" y1="41" x2="-45" y2="3" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8B06E6" />
          <stop offset="1" stopColor="#C42CF1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
